import { render, staticRenderFns } from "./ItThumb.vue?vue&type=template&id=10be947c&scoped=true"
import script from "./ItThumb.vue?vue&type=script&lang=ts"
export * from "./ItThumb.vue?vue&type=script&lang=ts"
import style0 from "./ItThumb.vue?vue&type=style&index=0&id=10be947c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10be947c",
  null
  
)

export default component.exports